import {
  Sun,
  CloudRain,
  CloudLightning,
  Snowflake,
  CloudFog,
  Star,
  Plane,
  TrendingUp,
} from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { WeatherCondition } from './price-calculator-types'

const WEATHER_ICONS: Record<WeatherCondition, React.ElementType> = {
  clear: Sun,
  rain: CloudRain,
  storm: CloudLightning,
  snow: Snowflake,
  fog: CloudFog,
}

interface PricingFactorPillProps {
  type: 'weather' | 'holiday' | 'aircraft' | 'occupancy'
  multiplier: number
  weather?: WeatherCondition
  label?: string
}

export function PricingFactorPill({ type, multiplier, weather, label }: PricingFactorPillProps) {
  if (multiplier <= 1.0) return null

  const pct = Math.round((multiplier - 1) * 100)

  let Icon: React.ElementType
  let text: string

  switch (type) {
    case 'weather':
      Icon = weather ? WEATHER_ICONS[weather] : CloudRain
      text = label || `+${pct}%`
      break
    case 'holiday':
      Icon = Star
      text = label || `+${pct}%`
      break
    case 'aircraft':
      Icon = Plane
      text = `+${pct}%`
      break
    case 'occupancy':
      Icon = TrendingUp
      text = `+${pct}%`
      break
  }

  return (
    <Badge variant="outline" className="text-[10px] px-1.5 py-0 h-5 gap-0.5 shrink-0">
      <Icon className="w-2.5 h-2.5" />
      <span>{text}</span>
    </Badge>
  )
}
